import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { CgClose } from 'react-icons/cg'
import { Circle, MapContainer, Marker, Polygon, Popup, TileLayer, useMap, useMapEvents } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import L from 'leaflet'
import _ from 'lodash'
import pin from "../assets/images/pin.png";
import DivBlock from "../components/divBlock";
import toast from "../components/toast";
import useEndpoints from "../api/useEndpoints";
import axios from "axios";
import Storages from "../helper/storages";
import SearchAddress from "../components/searchAddress";
// import SearchAddress from "../routes/private/actions/entrance/searchAddress";

export default function AddOriginAddress(props) {

    var [show, setShow] = useState(false)
    var [address, setAddress] = useState(undefined)
    var position = [36.31935058, 59.554662]
    var endpoints = useEndpoints()
    const handleShow = (e) => {
        setShow(true)
    };


    var getEshAddress = (eshCode) => {

        axios.get(endpoints.getEshAddress, {
            params: { eshCode },
        }).then((res) => {
            setAddress([res.data?.result])
        })

    }


    var [params, setParams] = useState(undefined)
    useEffect(() => {

        if (show) {
            if (props?.eshCode)
                getEshAddress(props?.eshCode)
            else
                setAddress([])

            if (props?.item) {
                setParams(props?.item)
            } else {
                setParams(undefined)
            }
        } else {
            setParams(undefined)
        }
    }, [show])
    useEffect(() => {
        if (props?.show) {
            setShow(true)
        }
    }, [props?.show])

    var newFirstChild

    if (props?.children)
        newFirstChild = React.cloneElement(
            props?.children?.length > 1
                ? props.children[0]
                : props.children,
            { onClick: handleShow });

    return (<>
        {newFirstChild}

        <Modal show={show}
            centered
            size="xl"
            onHide={() => {
                setShow(false)
                props?.onClose()
            }}
            style={{ background: ' rgba(0, 0, 0, 0.400)' }}>

            <Modal.Body className="card-header  p-0" dir="rtl">
                <h2 className="text-center text-danger py-2">جهت سرویس دهی بهتر موقعیت دقیق خود را بروی نقشه مشخص فرمایید |  {props?.eshCode}</h2>
                {
                    address ?
                        <MapContainer
                            className="w-100 card"
                            style={{ minHeight: '90vh' }}
                            zoom={12}
                            center={position}
                            zoomControl={false}
                            attributionControl={false}
                            scrollWheelZoom={true}>
                            <TileLayer
                                url="https://tile-b.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                            />
                            <MapController
                                params={params}
                                onResult={(location) => {
                                    setShow(false)
                                    props?.onResult(location)
                                }}
                                address={address}
                                onClose={() => {
                                    setShow(false)
                                    props?.onClose()
                                }}
                            />
                        </MapContainer>

                        : <></>
                }
            </Modal.Body>


        </Modal>
    </>)
}




function MapController(props) {
    const map = useMap()
    var [title, setTitle] = useState()

    var endpoints = useEndpoints()
    var [center, setCenter] = useState(map.getCenter())
    var [selectStList, setSelectedStList] = useState([])

    useEffect(() => {
        if (props?.address) {
            if (props?.address.length > 0) {
                setTitle(props?.address[0]?.address)
                setCenter([props?.address[0]?.lat, props?.address[0]?.lng])
                moveTo(props?.address[0]?.lat, props?.address[0]?.lng)
            }
        }


    }, [props?.address])



    useEffect(() => {
        var event = map.addEventListener("moveend", (e) => {
            console.log(map.getCenter())
            setCenter(map.getCenter())

        })
        return () => {
            map.removeEventListener("moveend", event)
        };
    }, []);

    var flyTo = (lat, lng) => {
        if (lat == undefined) return
        map.flyTo({ lat: lat, lng: lng }, 16)
    }
    var moveTo = (lat, lng) => {
        if (lat == undefined) return
        map.flyTo({ lat: lat, lng: lng }, 14, { animate: false })
    }

    useEffect(() => {
        try {
            flyTo(props?.flyTo?.lat, props?.flyTo?.lng)
        } catch (e) { }
    }, [props.flyTo])



    var [currentAddress, setCurrentAddress] = useState("")
    const getAddress = () => {
        var params = {
            lat: center.lat,
            lng: center.lng,
        };

        axios.get(endpoints?.loc2add, {
            params: params,
            headers:
            {
                'x-auth-token': Storages.getUserToken()
            }
        }).then((res) => {
            if (res?.data?.status)
                setCurrentAddress(res.data?.result)
        })
    };



    // const searchAddress = (searchAddress) => {
    //     var params = {
    //         lat: center.lat,
    //         lng: center.lng,
    //         term: searchAddress,
    //     };
    //     AxiosPrivate.get(endpoints.search, {
    //         params: params,
    //     }).then((res) => {
    //         setAddressesResult(res.data)
    //     })
    // };

    useEffect(() => {
        getAddress()
    }, [center])

    var [searchTerm, setSearchTerm] = useState()
    var [addressesResult, setAddressesResult] = useState([])

    // تابعی که می‌خواهید پس از تکمیل تایپ اجرا شود
    const doSomethingAfterUserHasStoppedTyping = (inputValue) => {
        console.log(`کاربر تایپ کردن را تمام کرد: ${inputValue}`);
        // searchAddress(inputValue)
        // اینجا کد مورد نظر خود را قرار دهید
    };

    // استفاده از debounce برای تاخیر در اجرای تابع
    const debouncedDoSomething = _.debounce(doSomethingAfterUserHasStoppedTyping, 300);

    useEffect(() => {
        if (searchTerm) {
            debouncedDoSomething(searchTerm);
        }
        // لغو debounce در صورت unmount شدن کامپوننت
        return () => {
            debouncedDoSomething.cancel();
        };
    }, [searchTerm]); // فقط زمانی اجرا می‌شود که مقدار value تغییر کند


    var [stCode, setStCode] = useState()

    var AddFrequentAddress = () => {
        if (!title) {
            toast.Error('آدرس تکمیلی را وارد نمایید')
            return
        }

        var params = {
            fullAddress: title,
            lat: center?.lat,
            lng: center?.lng,
            findAddress: currentAddress?.address
        }
        props?.onResult(params)

        // axios.post(endpoints.pointIOFrequentAddress, params)
        //     .then((res) => {
        //         toast.Success(res?.data?.msg)
        //         props.onClose()
        //     })
    }
    return <>
        <div className="position-absolute bottom-50  d-flex justify-content-center noSelect "
            style={{ zIndex: 409, left: '45%', right: '45%', height: '4rem', paddingTop: '0.3rem' }}>
            <img
                src={pin}
                style={{ height: '4rem' }}
                className="aPointer"
            />
        </div>


        <DivBlock className="position-absolute bottom-0 start-0 end-0 p-3" style={{ zIndex: 409 }}>
            <div>
                <div className="row g-2">
                    <div className="col-12 pt-2">
                        <input className="form-control shadow mb-2 border-secondary "
                            placeholder="آدرس تکمیلی"
                            value={title}
                            onChange={(e) => { setTitle(e.target.value) }}
                        />
                    </div>


                </div>

                <p className="card iranSansBold p-2 mb-1 border-secondary">{currentAddress?.address}</p>
                <button className="btn btn-primary  shadow p-0 w-100 p-2 mt-0"
                    onClick={() => {
                        AddFrequentAddress()
                    }} >
                    ثبت آدرس
                </button>
            </div>

        </DivBlock >
        <DivBlock className="position-absolute start-0 end-0 p-2" style={{ zIndex: 409 }}>
            <div className=" d-flex">
                <SearchAddress
                    className="col form-control px-2 border-secondary"
                    center={{ lat: center?.lat, lng: center?.lng }}
                    calcPriceByRouting={true}
                    onSelectAddress={(item) => {
                        var newParams = {
                            // ...params,
                            destLat: item?.lat,
                            destLng: item?.lng,
                            destAddress: (item?.address?.includes(item?.title) ? '' : item?.title) + ' ' + item?.address,
                            offlineDistance: item?.distance,
                            offlineDuration: item?.duration,
                        }
                        flyTo(item.lat, item.lng)
                        //   setParams(newParams)
                        //   setFlyTo({ lat: item.lat, lng: item.lng })
                        //   setTripPrice(undefined)
                        //   setRoute([])
                        //   calcPrice(newParams)
                        //   mobileRef?.current?.focus()
                    }} />
                <div className="m-1" />

                <button className="btn btn-light shadow p-0  border-secondary"
                    style={{ height: '2.5rem', width: '2.5rem' }}
                    onClick={() => {
                        props?.onClose()
                    }} >
                    <CgClose className=" text-hover aPointer  p-2" size={40} />
                </button>
            </div>

        </DivBlock>


    </>
}